<div>
  <div class="add-title">
    <h2 class="primary" i18n="@@Create Replenishment Order">Create Replenishment Order</h2>
    <h3 class="primary">{{facilityInventoryProduct.title}}</h3>
  </div>
  <div>
    <form [formGroup]="formGroup" (change)="formChanged()">
      <mat-grid-list cols="2" [cols]="breakpoint" rowHeight="72px" (window:resize)="onResize($event)">
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="full-width">
              <mat-label i18n="@@Product">Product</mat-label>
              <mat-select formControlName="product_ID" required>
                <mat-option *ngFor="let product of products" [value]="product"
                            [class.primary-product-option]="product === primaryProductId">
                  <mat-icon *ngIf="product === primaryProductId"
                            style="color: gold; vertical-align: middle; margin-right: 4px;"
                            title="Primary product for this inventory item"
                            i18n-title="@@Primary product for this inventory item">star</mat-icon>
                  <span [style.font-weight]="product === primaryProductId ? 'bold' : 'normal'">{{product}}</span>
                  <span *ngIf="getProductTitle(product)" style="margin-inline-start: 6px; color: #555;">{{getProductTitle(product)}}</span>
                  <span *ngIf="product === primaryProductId" style="margin-inline-start: 6px; color: #888; font-size: smaller;" i18n="@@(primary)">(primary)</span>
                </mat-option>
<!--                <mat-option *ngFor="let product of products" [value]="product.ID">{{product.ID}} {{product.title}}</mat-option>-->
              </mat-select>
            </mat-form-field>
          </div>
        </mat-grid-tile>
<!--        <mat-grid-tile>-->
<!--          <div class="text-inside">-->
<!--            <mat-form-field class="full-width">-->
<!--              <mat-select  placeholder="Facility" i18n-placeholder="@@Facility" formControlName="facilityId" required>-->
<!--                <mat-option value="6" i18n="@@Houston" selected>Houston</mat-option>-->
<!--                <mat-option value="7" i18n="@@California">California</mat-option>-->
<!--                <mat-option value="1" i18n="@@Phoenix">Phoenix</mat-option>-->
<!--                <mat-option value="8" i18n="@@South Carolina">South Carolina</mat-option>-->
<!--              </mat-select>-->
<!--            </mat-form-field>-->
<!--          </div>-->
<!--        </mat-grid-tile>-->
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="full-width">
              <mat-label i18n="@@Quantity">Quantity</mat-label>
              <input matInput id="quantity" required type="number" min="1"  max="1500" formControlName="quantity">
            </mat-form-field>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="full-width">
              <mat-label i18n="@@Batch">Batch</mat-label>
              <input matInput id="batch" required type="text" formControlName="batch">
            </mat-form-field>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
      <div class="btn-sec">
        <button mat-raised-button type="button" class="Discard-btn" mat-dialog-close="" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
        <button mat-raised-button type="submit" color="primary" class="Update-btn" [disabled]="formGroup.invalid" (click)="onSave()" i18n="@@Create Replenishment Order">Create Replenishment Order</button>
      </div>
    </form>
  </div>
</div>
